module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/canal/canal.component.css
// module id = ./src/app/canal/canal.component.css
// module chunks = main